var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"SubWebPageStudent"},[_c('el-card',[_vm._v(" 建设中。。。 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }